<template>
  <v-container fluid> 
    <v-row>
             <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.reservationStatus')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.reservationStatusState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.packReservationStatus
                      ? getdrug.packReservationStatus
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.reservationDate')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.reservationDateState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    reserveDate
                      ? reserveDate
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.reservationTimeout')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.reservationTimeoutState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.packReservationTimeout
                      ? getdrug.packReservationTimeout
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.reservationTimeoutDate')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.reservationTimeoutDateState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                     {{
                    timeoutDate
                      ? timeoutDate
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.reservedByFarmId')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.reservedByFarmIdState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.packReservedByFarmId
                      ? getdrug.packReservedByFarmId                                                                                                                                                                                                                 
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.reservedByKeeperId')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.reservedByKeeperIdState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.packReservedBykeeperId
                      ? getdrug.packReservedBykeeperId
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "PackReservation",
       async mounted(){
    this.reserveDate= await this.dateFormat(this.getdrug.packReservationDate)
    this.timeoutDate= await this.dateFormat(this.getdrug.packReservationTimeoutDate)
  },
  computed: {
    ...mapGetters(["getdrug"]),
  },
        data(){
    return{
      reserveDate:"",
      timeoutDate:""
    }
  },
  props:["dateFormat"]
};
</script>